"use client";

import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";
import { DemoForm } from "@/components/forms/DemoForm/DemoForm";

export function BookCallSection() {
  return (
    <motion.section
      id="contact"
      className="py-12 lg:py-20 px-6"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeUp}
    >
      <div className="mx-auto">
        <DemoForm />
      </div>
    </motion.section>
  );
}
